const autoNgTemplateLoaderTemplate1 = require('./configuration.html');

angular.module('shbdeployer.kubernetes').component('kubernetesConfigurationView', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller: 'KubernetesConfigurationController',
  controllerAs: 'ctrl',
  bindings: {
    $transition$: '<',
  },
});
